import { render, staticRenderFns } from "./Section7thIm.vue?vue&type=template&id=28dfa3d9&scoped=true&"
import script from "./Section7thIm.vue?vue&type=script&lang=js&"
export * from "./Section7thIm.vue?vue&type=script&lang=js&"
import style0 from "./Section7thIm.vue?vue&type=style&index=0&id=28dfa3d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dfa3d9",
  null
  
)

export default component.exports